export function getColumnMappingName(value: string, columnIndex: number, prefix?: string): string {
    if (value === '') {
        return `Column ${columnIndex + 1} (${prefix ? prefix + ' ' : ''}Empty)`;
    }

    return `Column ${columnIndex + 1} (${prefix ? prefix + ' ' : ''}${value})`;
}
